import { FavouriteConditionValue } from 'app/types-shared';
import { createInitialDefaultValue } from '../create-initial-default-value';
import { FilterTypes } from 'app/components/filters/types';

export const createInitialPersonConditions = (favouriteConditionValue: FavouriteConditionValue,
  conditionValues: FavouriteConditionValue[]) => {

  return {
    [FilterTypes.Person]: favouriteConditionValue.myValue
      ? { myValue: true } : createInitialDefaultValue(favouriteConditionValue, conditionValues)
  };
};
